var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M18.314,15.907A2.407,2.407,0,1,1,15.907,13.5,2.407,2.407,0,0,1,18.314,15.907Z",
    transform: "translate(-6.907 -6.907)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M16.555,12.955a1.35,1.35,0,0,0,.27,1.489l.049.049a1.637,1.637,0,1,1-2.315,2.315l-.049-.049a1.361,1.361,0,0,0-2.307.965v.139a1.636,1.636,0,0,1-3.273,0V17.79a1.35,1.35,0,0,0-.884-1.235,1.35,1.35,0,0,0-1.489.27l-.049.049a1.637,1.637,0,1,1-2.315-2.315l.049-.049A1.361,1.361,0,0,0,3.275,12.2H3.136a1.636,1.636,0,0,1,0-3.273H3.21a1.35,1.35,0,0,0,1.235-.884,1.35,1.35,0,0,0-.27-1.489l-.049-.049A1.637,1.637,0,1,1,6.442,4.192l.049.049a1.35,1.35,0,0,0,1.489.27h.065a1.35,1.35,0,0,0,.818-1.235V3.136a1.636,1.636,0,1,1,3.273,0V3.21a1.361,1.361,0,0,0,2.307.965l.049-.049a1.637,1.637,0,1,1,2.315,2.315l-.049.049a1.35,1.35,0,0,0-.27,1.489v.065a1.35,1.35,0,0,0,1.235.818h.139a1.636,1.636,0,1,1,0,3.273H17.79a1.35,1.35,0,0,0-1.235.818Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.64055609f94cad4ee6a870a7becacfe8.svg";
export { ForwardRef as ReactComponent };